export default __webpack_public_path__ + "static/media/lobbey.8d1b61c6.gif";